import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./Servicios.css"
import imagenServicios from "../images/imagen-servicios.png"
import CardServicios from './CardServicios';
import GoogleAds from '../images/imagen-googleads.svg'
import Facebook from '../images/imagen-facebook.svg'
import Instagram from '../images/imagen-instagram.svg'
import Desarrollo from '../images/imagen-desarrollo.svg'
//import ManejoRedes from '../images/imagen-manejoredes.svg'
import { Button } from 'flowbite-react';
import { Link } from "react-scroll";
import ContentManager from '../images/imagen-content.svg'
import ConsultoriasUnoAUno from '../images/imagen-consultoria.svg'
//import GrowthPartner from '../images/imagen-geow.svg'
import AppoinmentSetting from '../images/imagen-setter.svg'
import CloserDeVentas from '../images/imagen-closer.svg'
import CapacitacionProcesos from '../images/imagen-capacitacion-procesos.svg'
import CapacitacionGrowth from '../images/imagen-capacitaciones.svg'

const buttonStyleAzul = {
    backgroundColor: '#111125',
    color: 'white',
    borderRadius: '28px',
    fontFamily: 'Inter, sans-serif', 
    fontSize: '24px',
    fontWeight: 'semi-bold',
  };
function Servicios() {
  return (
    <>
    <Container>
        
    </Container>
    <Container className='contenedor-servicios'>
    <Row>
            <Col className='col-md-8 col-sm-12'>
            <h4 className='titulo-blanco-servicios'>Para alcanzar el <span className='titulo-azul-servicios'>éxito de tu negocio </span>tenes que tener cubiertas todas estas áreas</h4>
            </Col>
        </Row>
        <Row>        
            <Col className='col-md-7 col-sm-12 contenedorServicios'>
                {/* <h5 className='pretitulo-servicios'>Lorem Ipsum Dolor</h5> */}
                <CardServicios
                    imagen={ContentManager}
                    titulo={"Content Manager"}
                    descripcion={""}
                    color={'rgba(134, 181, 218, 0.55)'}/>
                <CardServicios
                    imagen={ConsultoriasUnoAUno}
                    titulo={"Consultorias 1 a 1"}
                    descripcion={""}
                    color={'rgba(134, 181, 218, 0.55)'}/>
                <CardServicios
                    imagen={Desarrollo}
                    titulo={"Desarrollo Web"}
                    descripcion={""}
                    color={'rgba(134, 181, 218, 0.55)'}/>
                <CardServicios
                    imagen={GoogleAds}
                    titulo={"Google Ads"}
                    descripcion={""}
                    color={'rgba(134, 181, 218, 0.55)'}/>
                <CardServicios
                    imagen={Facebook}
                    titulo={"Facebook Ads"}
                    descripcion={""}
                    color={'rgba(134, 181, 218, 0.55)'}/>
                <CardServicios
                    imagen={CapacitacionGrowth}
                    titulo={"Capacitaciones Growth Partner"}
                    descripcion={""}
                    color={'rgba(134, 181, 218, 0.55)'}/>
                <CardServicios
                    imagen={Instagram}
                    titulo={"Instagram Ads"}
                    descripcion={""}
                    color={'rgba(134, 181, 218, 0.55)'}/>
                <CardServicios
                    imagen={AppoinmentSetting}
                    titulo={"Appointment Setting"}
                    descripcion={""}
                    color={'rgba(134, 181, 218, 0.55)'}/>
                <CardServicios
                    imagen={CloserDeVentas}
                    titulo={"Closer de Ventas"}
                    descripcion={""}
                    color={'rgba(134, 181, 218, 0.55)'}/>
                <CardServicios
                    imagen={CapacitacionProcesos}
                    titulo={"Capacitación de procesos de adquisición y monetización de clientes"}
                    descripcion={""}
                    color={'rgba(134, 181, 218, 0.55)'}/>
            </Col>
            <Col className="d-flex align-items-center col-md-5 d-none d-sm-block">
                <div className='contenedor-imagen'>
                    <img src={imagenServicios} className="imagenInicio d-flex align-items-center" alt="logo" />
                </div>
            </Col>
        </Row>
        <Row>
            <Col className='col-md-7 col-sm-12'>
                <p className='parrafo'>Y en FHP estamos capacitados para brindarte cada uno de estos servicios.</p>
                <div className='contenedor-boton gap-2'>
                    <Link  to='calendly' smooth={false} offset={-70} duration={700} color="text">
                        <Button className='mt-10 p-0' size="lg" style={buttonStyleAzul}>Agendemos una llamada</Button>
                    </Link>
                </div>
            </Col>
        </Row>
        
    </Container>
    </>
  )
}

export default Servicios
